import { Component, Inject, OnInit, DOCUMENT, ChangeDetectionStrategy } from '@angular/core';
import { RouterParamSeervice } from './service/params/params.service';
import { TranslateService } from '@ngx-translate/core';
import { FeatureService } from './shared/modules/feature/feature.service';
import { environment } from 'src/environments/environment';

import { Location } from '@angular/common';
import { firstValueFrom } from 'rxjs';
import {Router} from "@angular/router";
import {LocalizationService} from "./service/localization/localization.service";

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AppComponent implements OnInit {
  title = 'ak-registration-frontend';
  isocode: string = '';
  languageCode: string = '';
  countryCode: string = '';
  init: boolean = false;
  initLanguages: boolean;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    public params: RouterParamSeervice,
    private translation: TranslateService,
    private feature: FeatureService,
    private location: Location,
    private router: Router,
    private  localizationService: LocalizationService
) {}

  ngOnInit(): void {
    this.params.params$.subscribe(async (param) => {
      if (param['isocode'] !== undefined && this.isocode !== param['isocode']) {
        this.isocode = param['isocode'];

        try {
          if (this.isocode === 'localization') {
            await this.handleLocalizationParam();
          } else {
            await this.handleIsoCodeParam();
          }
          if(this.isocode != 'en-default'){
            await this.updateRouteAndTranslation();
          }
        } catch (error) {
          console.error('Error during localization setup:', error);
          // Fallback to default values
          this.translation.use('en');
          this.feature.use('default');
        }
      }
      this.init = true;
    });

    if (navigator.userAgent.indexOf('iPhone') > -1) {
      this.document
        .querySelector('[name=viewport]')
        ?.setAttribute(
          'content',
          'width=device-width, initial-scale=1, maximum-scale=1'
        );
    }
  }

  private async handleLocalizationParam(): Promise<void> {
    const localizationObject: any = await firstValueFrom(this.localizationService.getLocalization());
    this.countryCode = localizationObject.country === '' ?  "default" : localizationObject.country.toUpperCase();
    await this.feature.use(this.countryCode);
    const configuredLanguages: string[] = this.feature.activated('lang');
    console.log(configuredLanguages)
    const browserLanguage = navigator.language.toLowerCase();
    const browserLanguages = navigator.languages;
    if (configuredLanguages.includes(browserLanguage)) {
      this.isocode = `${browserLanguage}-${this.countryCode}`;
      this.languageCode = browserLanguage;
    }
    else {

      const matchedLanguage = browserLanguages
        .map((lang) => lang.toLowerCase())
        .find((lang) => configuredLanguages.includes(lang));

      if (matchedLanguage) {
        this.isocode = `${matchedLanguage}-${this.countryCode}`;
        this.languageCode = matchedLanguage;
      } else {
        this.isocode = `${configuredLanguages[0]}-${this.countryCode}`;
        this.languageCode = configuredLanguages[0];
      }
    }
  }

  private async handleIsoCodeParam(): Promise<void> {
    [this.languageCode, this.countryCode] = this.isocode.split('-');
    this.languageCode = this.languageCode.toLowerCase();
    this.countryCode = this.countryCode.toUpperCase();

    await this.feature.use(this.countryCode);

    const configuredLanguages: string[] = this.feature.activated('lang');
    if (!configuredLanguages.includes(this.languageCode)) {
      this.isocode = `${configuredLanguages[0]}-${this.countryCode}`;
      this.languageCode = configuredLanguages[0];
    }
  }

  private async updateRouteAndTranslation(): Promise<void> {
    const path = this.location.path();
    const removeLocalPath = path.replace("/localization", "");
    const cleanPath = removeLocalPath.replace("/" + this.isocode, "");
    this.location.replaceState(this.isocode + cleanPath);
    await firstValueFrom(this.translation.use(this.isocode));
  }
}
